var React = require('react');

function IconCaseArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow","transform":"translate(0.75 1.059)"},React.createElement("g",{"id":"arrow-2","data-name":"arrow","transform":"translate(10 9) rotate(180)"},[React.createElement("path",{"id":"パス_3763","data-name":"パス 3763","d":"M.5,5.5,5,.5l4.5,5","transform":"translate(10.5 -0.5) rotate(90)","fill":"none","stroke":"#666","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"線_11","data-name":"線 11","y1":"10","transform":"translate(10 4.5) rotate(90)","fill":"none","stroke":"#666","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":1})])));
}

IconCaseArrowLeft.defaultProps = {"width":"11.5","height":"11.118","viewBox":"0 0 11.5 11.118"};

module.exports = IconCaseArrowLeft;

IconCaseArrowLeft.default = IconCaseArrowLeft;
